var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8286.9,4851.2l-53.2-40.9V110v-4700.3l53.2-40.9c53.2-40.9,77.7-42.9,785.1-42.9c689,0,734,2,778.9,38.9l49.1,38.8V110v4706.4l-49.1,38.8c-45,36.8-89.9,38.8-778.9,38.8C8364.6,4894.1,8340.1,4892.1,8286.9,4851.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2903.8,2931.4c-24.5-10.2-53.1-36.8-65.4-59.3c-16.4-28.6-22.5-1165.4-22.5-3751.6v-3710.8l53.2-40.9c53.2-40.9,77.7-42.9,776.9-42.9c396.6,0,736,6.1,754.4,12.3c96.1,36.8,92-118.6,92,3810.9v3684.2l-59.3,59.3l-59.3,59.3l-713.5-2C3269.7,2949.8,2928.3,2941.6,2903.8,2931.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5565.7,1674l-51.1-49.1v-3079c0-3283.4-4.1-3171,92-3207.8c18.4-6.1,357.8-12.3,754.4-12.3c699.2,0,723.7,2,776.9,42.9l53.2,40.9v3113.8v3113.7l-47,42.9c-47,45-55.2,45-789.2,45h-740.1L5565.7,1674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,173.4l-49.1-38.8l-6.1-2318.5c-2-1273.7,0-2336.8,6.1-2363.4c6.1-24.5,28.6-63.4,51.1-85.9c38.8-38.8,71.6-40.9,774.9-40.9c709.4,0,734,2,787.1,42.9l53.2,40.9v2359.3V128.4l-53.2,40.9c-53.2,40.9-77.7,42.9-785.1,42.9C245.9,212.2,200.9,210.2,156,173.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.13fec0bb160bda69fee4dd6218869255.svg";
export { ForwardRef as ReactComponent };